module.exports = __webpack_public_path__ + "img/fengcai3.9621a798.png";